// extracted by mini-css-extract-plugin
export default {"status-label":"sqqr","statusLabel":"sqqr","no-content":"jtHU","noContent":"jtHU","message":"ryZt","link":"cyeq","error":"QVdp","success":"nphE","warning":"VvqB","info":"vjXV"};